import { create } from "domain";
export const forms_layout_actions = {
   addLeagueInfo: (state:any, action:{payload:any}) => {
    state.league ={ ...state.league, ...action.payload };
  },
  selectLeagueInfo: (state:any, action:{payload:any}) => {
    state.currentLeague = action.payload;
  },
  resetLeagueInfo: (state:any) => {
    state.currentLeague = {};
  },
   selectEventInfo: (state:any, action:{payload:any}) => {
    state.currentEvent = action.payload;
  },
  resetEventInfo: (state:any) => {
    state.currentEvent = {};
  },
  reset: (state:any) => {
    state.league = {};
  },
};